









































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { AsesmenAnakGadarValue } from "@/types/asesmen_gawat_darurat";
import {
  DOWN_KEYS,
  DOWN_KOMPONEN,
  DownItemKey,
  DownItems,
  DownJawaban,
  DownKomponen,
  downAdaIsian,
  downItemsKosong,
  downKategori,
  downLabelKategori,
  downLabelKategoriRingkas,
  downLengkap,
  downNormalizeItems,
  downTerisi,
  downTotal,
  downWarna
} from "@/utils/downScore";
import {
  SAGA_KEYS,
  SAGA_KOMPONEN,
  SagaItemKey,
  SagaItems,
  SagaKomponen,
  sagaAdaIsian,
  sagaItemsKosong,
  sagaKesimpulan,
  sagaKomponenAbnormal,
  sagaLabelKesimpulan,
  sagaLengkap,
  sagaNormalizeItems,
  sagaWarna,
  sagaZona
} from "@/utils/sagaAnak";

@Component({
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class AsesmenAnakGadar extends Vue {
  @Prop() readonly value;
  @Prop({ type: String, default: "Asesmen Gawat Darurat Anak" })
  readonly title!: string;

  isReadOnly!: () => boolean;

  downScore = null;
  apgar1min = null;
  apgar5min = null;
  bb = null;
  tb = null;
  saga: SagaItems = sagaItemsKosong();
  down: DownItems = downItemsKosong();
  downDisentuh = false;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get downKomponen(): DownKomponen[] {
    return DOWN_KOMPONEN;
  }

  get downAda(): boolean {
    return downAdaIsian(this.down);
  }

  get downSudahLengkap(): boolean {
    return downLengkap(this.down);
  }

  get downTerisiJumlah(): number {
    return downTerisi(this.down);
  }

  get downTotalHitung(): number | null {
    return downTotal(this.down);
  }

  get downKategoriKode(): string | null {
    return downKategori(this.downTotalHitung);
  }

  get downLabelRingkas(): string {
    return downLabelKategoriRingkas(this.downKategoriKode);
  }

  get downWarnaChip(): string {
    return downWarna(this.downKategoriKode);
  }

  get downNilaiTampil(): string {
    if (this.downTotalHitung !== null) {
      return String(this.downTotalHitung);
    }

    if (this.downAda || this.downDisentuh) {
      return "";
    }

    return this.downScore === null || this.downScore === undefined
      ? ""
      : String(this.downScore);
  }

  get downKeterangan(): string[] {
    const label = downLabelKategori(this.downKategoriKode);

    return label ? [label] : [];
  }

  setDownItem(key: DownItemKey, val) {
    if (this.readOnly) {
      return;
    }

    this.downDisentuh = true;

    const angka =
      val === null || val === undefined || val === "" ? null : Number(val);
    const next: DownJawaban =
      angka !== null && Number.isFinite(angka) && angka >= 0 && angka <= 2
        ? (Math.trunc(angka) as DownJawaban)
        : null;

    if (this.down[key] !== next) {
      this.down[key] = next;
    }
  }

  bersihkanDown() {
    if (this.readOnly) {
      return;
    }

    this.downDisentuh = true;

    DOWN_KEYS.forEach(key => {
      if (this.down[key] !== null) {
        this.down[key] = null;
      }
    });
  }

  get sagaKomponen() {
    const abnormal = sagaKomponenAbnormal(this.saga);

    return SAGA_KOMPONEN.map(komponen => ({
      ...komponen,
      abnormal: abnormal[komponen.key]
    }));
  }

  get sagaAda(): boolean {
    return sagaAdaIsian(this.saga);
  }

  get sagaSudahLengkap(): boolean {
    return sagaLengkap(this.saga);
  }

  get sagaLabel(): string {
    return sagaLabelKesimpulan(sagaKesimpulan(this.saga));
  }

  get sagaWarnaChip(): string {
    return sagaWarna(sagaZona(sagaKesimpulan(this.saga)));
  }

  setSagaItem(key: SagaItemKey, val) {
    if (this.readOnly) {
      return;
    }

    const next = val === null || val === undefined ? null : !!val;

    if (this.saga[key] !== next) {
      this.saga[key] = next;
    }
  }

  bersihkanKomponen(komponen: SagaKomponen) {
    if (this.readOnly) {
      return;
    }

    komponen.items.forEach(item => {
      if (this.saga[item.key] !== null) {
        this.saga[item.key] = null;
      }
    });
  }

  get asesmenAnak(): AsesmenAnakGadarValue {
    return {
      downScore: this.downScore,
      apgar1min: this.apgar1min,
      apgar5min: this.apgar5min,
      bb: this.bb,
      tb: this.tb,
      saga: { ...this.saga },
      downItems: { ...this.down }
    };
  }

  set asesmenAnak(val: AsesmenAnakGadarValue) {
    this.downScore = this.normalize(val?.downScore);
    this.apgar1min = this.normalize(val?.apgar1min);
    this.apgar5min = this.normalize(val?.apgar5min);
    this.bb = this.normalize(val?.bb);
    this.tb = this.normalize(val?.tb);

    const src = sagaNormalizeItems(val?.saga);

    SAGA_KEYS.forEach(key => {
      if (this.saga[key] !== src[key]) {
        this.saga[key] = src[key];
      }
    });

    const srcDown = downNormalizeItems(val?.downItems);

    DOWN_KEYS.forEach(key => {
      if (this.down[key] !== srcDown[key]) {
        this.down[key] = srcDown[key];
      }
    });
  }

  normalize(val) {
    return !val && val != 0 ? null : val;
  }

  mounted() {
    if (this.value) {
      this.asesmenAnak = this.value;
    }
  }

  @Watch("asesmenAnak", { deep: true })
  changeAsesmenAnak(val: AsesmenAnakGadarValue) {
    this.$emit("setValue", val);
  }

  @Watch("value", { deep: true })
  changeValue(val: AsesmenAnakGadarValue) {
    this.asesmenAnak = val;
  }
}
